<app-nav-grouping-student-index
*ngIf="subscriptionGrouping"
[subscriptionGrouping]="subscriptionGrouping">

</app-nav-grouping-student-index>
<div class="row" *ngIf="subscriptionGrouping">
  <div class="col-sm-12">
    <div class="sub-title alert alert-info text-center">
      <h4>Students for Grouping {{groupingName}}</h4>
      <h5>{{groupName}}</h5>
    </div>
  </div>

</div>
<div class="table-responsive" *ngIf="subscriptionGroupingStudentList">

<table datatable [dtOptions]="dtOptions" class="table table-striped display compact">
  <thead>
  <tr>
    <th></th>
    <th>Names</th>
    <th>Email</th>
    <th>Subscription</th>
    <th>Status</th>
  </tr>
  </thead>

  <tbody>

  <tr *ngFor="let student of subscriptionGroupingStudentList;">
      <td>{{student.server_student_id}}</td>
     <td>
      <a [routerLink]="['/admin/student/manage',student.server_user_id]">
         {{student.fullname}}
      </a>
      </td>

      <td>
        {{student.email}}
      </td>
      <td>
        {{subscriptionTypeName(student)}}
      </td>
      <td>
        {{subscriptionStatus(student)}}
      </td>
  </tr>

  </tbody>

</table>

</div>

<app-spinner *ngIf="subscriptionGroupingStudentList && loading"></app-spinner>
<div *ngIf="!subscriptionGroupingStudentList && !loading" class="text-center">No Records Found </div>
<app-subscription-grouping-student-new *ngIf="subscriptionGrouping"
[subscriptionGrouping]="subscriptionGrouping">

</app-subscription-grouping-student-new>


